import script from "./queryList.vue?vue&type=script&setup=true&lang=js"
export * from "./queryList.vue?vue&type=script&setup=true&lang=js"

import "./queryList.vue?vue&type=style&index=0&id=64d01c67&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64d01c67"]])

export default __exports__